import cn from 'classnames';
import React from 'react';
import {connect} from 'react-redux';
import {createStructuredSelector} from 'reselect';

import BackButton from '../../../components/BackButton/BackButton';
import {MaxWidthContainer} from '../../../components/Layout';
import {PopupFullPage} from '../../../components/Popup';
import * as localizationKeys from '../../../consts/localization/localizationKeys';
import * as routePaths from '../../../consts/route/routePaths';
import useDocumentTitle from '../../../hooks/useDocumentTitle';
import {getLocalizedStrings} from '../../../services/localization/localizationService';
import tncService from '../../../services/tncService';
import {removeLastTncPopupCode} from '../../../state/ducks/tnc';
import {makeSelectTncLegals} from '../../../state/selectors/consumer';
import {selectTncPopupCodesList} from '../../../state/selectors/tnc';
import elementsTesIds from '../../../test/consts/elementsTesIds';
import TermsOfUseDescription from '../TermsOfUseDescription/TermsOfUseDescription';
import styles from '../TermsOfUsePage/TermsOfUsePage.module.scss';

const mapStateToProps = createStructuredSelector({
    legals: makeSelectTncLegals(),
    tncPopupCodesList: selectTncPopupCodesList,
});

const TermsOfUsePopup = (props) => {
    const {dispatch, tncPopupCodesList, legals, matchProps} = props;
    const {pathname} = matchProps.location;
    const [backBtnAriaLabel, titleKey] = getPathRelatedData(pathname);
    const tncPopupCode = tncPopupCodesList.slice(-1)[0];
    const legalData = tncService.getTncLegalByTermsCode(legals, tncPopupCode);
    const {title, text} = legalData || {};

    if (!legalData) {
        dispatch(removeLastTncPopupCode());
    }

    const onClose = () => {
        dispatch(removeLastTncPopupCode());
    };

    useDocumentTitle(titleKey, true);

    return (
        <PopupFullPage contentLabel={title} testId={elementsTesIds.LEGAL_AND_POLICY_POPUP} key={tncPopupCode}>
            <MaxWidthContainer>
                <BackButton
                    ariaLabel={backBtnAriaLabel}
                    onClick={onClose}
                    testId={elementsTesIds.LEGAL_AND_POLICY_BTN_BACK}
                />
            </MaxWidthContainer>
            <section className={styles.PopupContent}>
                <section>
                    <h1 className={cn(styles.LineTitle, 'sm:mb-16')}>{title}</h1>
                </section>
                <section>
                    <TermsOfUseDescription innerHtml={text} className={cn(styles.DescriptionContainer, 'mt-12')} />
                </section>
            </section>
        </PopupFullPage>
    );
};

export default connect(mapStateToProps)(TermsOfUsePopup);

const getPathRelatedData = (pathname) => {
    const localizedStrings = getLocalizedStrings();

    if (pathname.includes(routePaths.DEVICE_SETTINGS)) {
        return [
            localizedStrings[localizationKeys.LEGAL_AND_POLICY_PAGE_BTN_BACK_ARIA_LABEL],
            localizedStrings[localizationKeys.LEGAL_AND_POLICY_PAGE_TITLE],
        ];
    } else if (routePaths.TNC_TERMS_OF_USE === pathname) {
        return [
            localizedStrings[localizationKeys.TERMS_OF_USE_PAGE_BTN_USER_RETURN_TCP_ARIA_LABEL],
            localizedStrings[localizationKeys.TERMS_OF_USE_PAGE_TITLE],
        ];
    } else if (routePaths.TNC_DATA_COLLECTION === pathname) {
        return [
            localizedStrings[localizationKeys.DATA_COLLECTION_PAGE_BTN_RETURNS_USER_ARIA_LABEL],
            localizedStrings[localizationKeys.DATA_COLLECTION_PAGE_TITLE],
        ];
    } else {
        return [null, null];
    }
};
